import { EditCategoryGroup } from './../../../../../models/inModels/CategoryGroup';
import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessService } from '../../../../../services/business/business-category.service';
import { StorageService } from '../../../../../services/system/storage.service';

@Component({
  selector: 'app-category-group-edit',
  templateUrl: './category-group-edit.component.html',
  styleUrls: ['./category-group-edit.component.css']
})
export class CategoryGroupEditComponent implements OnInit {
  id;
  model: EditCategoryGroup;
	loading = false;
	error: Message[];
  uploading = false;
  groups;
  constructor(
    private route: ActivatedRoute,
		private router: Router,
		private businessService: BusinessService,
		private storageService: StorageService
  ) { 
		this.id = this.route.snapshot.paramMap.get('Id');
  }

  ngOnInit(): void {
    this.getGroup();
  }

  getGroup() {
    this.loading = true;
    this.businessService.getGroup(this.id).then(
      result => {
        this.model = new EditCategoryGroup(result);
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  goBack(): void {
		this.router.navigate(['business-category/groups']);
  }
  
  save() {
		this.loading = true;
		this.businessService.updateGroup(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditCategoryGroup(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Category saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }
  
  handleImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.icon = result.PublicId;
		this.loading = false;
  }
  
  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
  }
  
  removeImage(): void {
		this.model.icon = null;
		this.loading = false;
	}

  handleTenderImage(event): void {
    var result = this.storageService.handleSuccess(event);

		this.model.tenderIcon = result.PublicId;
		this.loading = false;
  }

  removeTenderImage(): void {
		this.model.tenderIcon = null;
		this.loading = false;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/business/business-category/category-group/category-group-edit/category-group-edit.component.ts